export const benderStyle = Object.freeze({
  mainTitle: Object.freeze({
    text: 'כתבות שאולי פספסתם',
    fontSize: [ { until: 'm', value: 1, }, { from: 'm', value: 2, }, ],
  }),
  title: Object.freeze({
    fontSize: [
      { until: 'm', value: -2, },
      { from: 'm', until: 'l', value: -1, },
      { from: 'l', value: 0, },
    ],
  }),
  image: Object.freeze({
    aspect: 'vertical',
    width: '400',
    quality: 'auto',
  }),
});

export const listStyle = Object.freeze({
  header: {
    verticalType: [
      { until: 's', value: { step: 1, lines: 7, }, },
      { from: 's', until: 'xl', value: 1, },
      { from: 'xl', value: 0, },
    ],
    type: [
      { until: 's', value: { step: 1, lines: 7, }, },
      { from: 's', until: 'l', value: 1, },
      { from: 'l', until: 'xl', value: 2, },
      { from: 'xl', value: 1, },
    ],
  },
});
